









































import { Component, Vue, Watch } from 'vue-property-decorator';
import LoginComponent from '@/components/login/login.component.vue';
import { State } from 'vuex-class';
import { CognitoUser } from '@aws-amplify/auth';
const namespace = 'profile';

@Component({ components: { LoginComponent } })
export default class LoginPage extends Vue {
  @State('newPasswordRequired', { namespace }) newPasswordRequired!: boolean;
  @State('cognitoUser', { namespace }) cognitoUser?: CognitoUser;

  mounted() {
    // Si déjà en challenge (ex: retour page / refresh)
    if (this.newPasswordRequired && this.cognitoUser) {
      this.$router.push({ name: 'signup' });
    }
  }

  @Watch('newPasswordRequired')
  onNewPasswordRequired(val: boolean) {
    if (val && this.cognitoUser) {
      this.$router.push({ name: 'signup' });
    }
  }
}
